import React, { useEffect, useState } from "react";
import { fetchAdminProfile } from "../../../api/api";
import { useNavigate } from "react-router-dom";
import styles from "./AdminProfile.module.css";
import useAuthGuard from "../../../hooks/useAuthGuard";

const AdminProfile = () => {
  const navigate = useNavigate();

  useAuthGuard();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        if (!token) {
          console.error("No admin token found");
          throw new Error("Authentication token not found.");
        }
        console.log("Fetching profile with token:", token.substring(0, 20) + "...");
        const response = await fetchAdminProfile(token);
        console.log("Profile response:", response.data);
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
        alert("Failed to load profile. Please try logging in again.");
      }
    };

    fetchProfile();
  }, []);

  if (!profile) {
    return <div className={styles.loading}>Loading...</div>;
  }

  return (
    <div className={styles.profileContainer}>
      <h2>{profile.role === 'stringer' ? 'Stringer' : 'Admin'} Profile</h2>
      <p>
        <strong>Name:</strong> {profile.first_name} {profile.last_name}
      </p>
      <p>
        <strong>Email:</strong> {profile.email}
      </p>
      <p>
        <strong>Role:</strong> {profile.role}
      </p>
      {profile.location && (
        <p>
          <strong>Location:</strong> {profile.location}
        </p>
      )}
      <p>
        <strong>Created At:</strong>{" "}
        {new Date(profile.date_created).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </p>
      <button
        className={styles.forgotButton}
        onClick={() => navigate("/forgot-password")}
      >
        Forgot Password?
      </button>
    </div>
  );
};

export default AdminProfile;
